/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  if ($(window).width() > 799) {
    var sr = ScrollReveal();

    sr.reveal('.creators-testimonial__title', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    sr.reveal('.creators-testimonial__card.swiper-slide', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true,
      interval: 40
    });
  }

  var swiperInstance = null;
  var resizeTimer;

  function updateNav(swiper) {
    var $nav = $('.creators-testimonial__nav');
    if (swiper.slides.length === 0 || swiper.wrapperEl.scrollWidth <= swiper.wrapperEl.clientWidth + 1) {
      $nav.hide();
    } else {
      $nav.show();
    }
  }

  function initSwiper() {
    if (swiperInstance) return;

    var sliderEl = document.querySelector('.js-creators-swiper');
    if (!sliderEl) return;

    var sectionId = sliderEl.dataset.sectionId;

    swiperInstance = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 20,
       grabCursor: true,
    speed: 300,
    resistanceRatio: 0.85,
    touchRatio: 1,
    touchAngle: 45,
    threshold: 3,
    followFinger: true,
    touchStartPreventDefault: false,
    touchMoveStopPropagation: false,
    nested: true,
    edgeSwipeDetection: true,
    edgeSwipeThreshold: 20,
    watchSlidesProgress: true,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.4,
      momentumVelocityRatio: 1,
      momentumBounce: false,
      sticky: false,
      minimumVelocity: 0.02,
    },
    cssMode: false,
    keyboard: { enabled: true, onlyInViewport: true },
    mousewheel: { forceToAxis: true, sensitivity: 0.5, releaseOnEdges: true },
      navigation: {
        prevEl: '.js-benefits-prev[data-section-id="' + sectionId + '"]',
        nextEl: '.js-benefits-next[data-section-id="' + sectionId + '"]',
      },
      on: {
        init: function () {
          var swiper = this;
          setTimeout(function () { updateNav(swiper); }, 0);
        },
        resize: function () {
          var swiper = this;
          setTimeout(function () { updateNav(swiper); }, 0);
        },
        slideChange: function () {
          updateNav(this);
        }
      }
    });
  }

  function destroySwiper() {
    if (!swiperInstance) return;
    swiperInstance.destroy(true, true);
    swiperInstance = null;

    var $wrapper = $('.js-creators-swiper .swiper-wrapper');
    $wrapper.removeAttr('style');
    $wrapper.find('.swiper-slide').removeAttr('style');
    $('.creators-testimonial__nav').hide();
  }

  function handleResize() {
    var w = window.innerWidth;
    if (w >= 800 && w <= 1279) {
      initSwiper();
    } else {
      destroySwiper();
    }
  }

  handleResize();
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 150);
  });

  function openPopup($overlay) {
    $overlay.addClass('is-active');
    $('html').addClass('popup-open');
    if (window.lenis) window.lenis.stop();
    var video = $overlay.find('video')[0];
    if (video) {
      video.currentTime = 0;
      video.play();
    }
  }

  function closeAll() {
    $('.creators-testimonial__popup-overlay').each(function () {
      var video = $(this).find('video')[0];
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
    $('.creators-testimonial__popup-overlay').removeClass('is-active');
    $('html').removeClass('popup-open');
    if (window.lenis) window.lenis.start();
  }

  $(document).on('click', '.creators-testimonial__show-more.desktop', function () {
    var popupId = $(this).data('popup');
    var $overlay = $('.creators-testimonial__popup-overlay[data-popup-id="' + popupId + '"]');
    openPopup($overlay);
  });

  $(document).on('click', '.creators-testimonial__image-wrapper', function (e) {
    if (window.innerWidth <= 799) return;
    if ($(e.target).closest('.creators-testimonial__show-more').length) return;
    var popupId = $(this).find('.creators-testimonial__show-more').data('popup');
    var $overlay = $('.creators-testimonial__popup-overlay[data-popup-id="' + popupId + '"]');
    openPopup($overlay);
  });

  $(document).on('click', '.creators-testimonial__card', function (e) {
    if (window.innerWidth > 799) return;
    if ($(e.target).closest('.creators-testimonial__show-more').length) return;
    var popupId = $(this).find('.creators-testimonial__show-more').data('popup');
    var $overlay = $('.creators-testimonial__popup-overlay[data-popup-id="' + popupId + '"]');
    openPopup($overlay);
  });

  $(document).on('click', '.creators-testimonial__popup-close', function () {
    closeAll();
  });

  $(document).on('click', '.creators-testimonial__popup-overlay', function (e) {
    if ($(e.target).hasClass('creators-testimonial__popup-overlay')) {
      closeAll();
    }
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
});